/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LinerInspectionReportGeneratorWallRequest
 */
export interface LinerInspectionReportGeneratorWallRequest {
    /**
     * 
     * @type {number}
     * @memberof LinerInspectionReportGeneratorWallRequest
     */
    id?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof LinerInspectionReportGeneratorWallRequest
     */
    fileIds?: Array<number>;
}

/**
 * Check if a given object implements the LinerInspectionReportGeneratorWallRequest interface.
 */
export function instanceOfLinerInspectionReportGeneratorWallRequest(value: object): value is LinerInspectionReportGeneratorWallRequest {
    return true;
}

export function LinerInspectionReportGeneratorWallRequestFromJSON(json: any): LinerInspectionReportGeneratorWallRequest {
    return LinerInspectionReportGeneratorWallRequestFromJSONTyped(json, false);
}

export function LinerInspectionReportGeneratorWallRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinerInspectionReportGeneratorWallRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'fileIds': json['fileIds'] == null ? undefined : json['fileIds'],
    };
}

export function LinerInspectionReportGeneratorWallRequestToJSON(json: any): LinerInspectionReportGeneratorWallRequest {
    return LinerInspectionReportGeneratorWallRequestToJSONTyped(json, false);
}

export function LinerInspectionReportGeneratorWallRequestToJSONTyped(value?: LinerInspectionReportGeneratorWallRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'fileIds': value['fileIds'],
    };
}

